import { render, staticRenderFns } from "./SuggestionCategoryHeader.vue?vue&type=template&id=709a9a54&"
import script from "./SuggestionCategoryHeader.vue?vue&type=script&lang=js&"
export * from "./SuggestionCategoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionCategoryHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports